import * as THREE from 'three';

export class Objective {
  health: number;
  maxHealth: number;
  readonly position: THREE.Vector3;

  constructor(position: THREE.Vector3, maxHealth = 20) {
    this.position = position.clone();
    this.maxHealth = maxHealth;
    this.health = maxHealth;
  }

  takeDamage(amount: number): void {
    this.health = Math.max(0, this.health - amount);
  }

  isDestroyed(): boolean {
    return this.health <= 0;
  }

  reset(): void {
    this.health = this.maxHealth;
  }
}
